import styled from 'styled-components';

export const InfoSection = styled.div<{ clickable?: boolean }>`
  padding-top: 1%;
  padding-bottom: 1%;
  width: 100%;

  &:first-of-type {
    padding-top: 0;
  }

  cursor: ${(props) => (props.clickable ? 'pointer' : 'unset')};

  &:hover {
    background-color: ${(props) =>
      props.clickable ? props.theme.palette.background.default : 'none'};
    border-radius: ${(props) => (props.clickable ? '10px' : '0')};
  }
`;

export const YesOrNo = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: bold;
  padding-top: 5px;
  padding-bottom: 5px;
`;

export const Approvedh2 = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
`;

export const ApprovedDiv = styled.div`
  border-left: 2px solid ${({ theme }) => theme.palette.primary.main};
  padding-left: 10px;
`;
